import ContainedFileViewerModal from './ContainedFileViewerModal';

export default ContainedFileViewerModal;
